import { orderBy } from 'lodash';
import { Button, IconEndAdornment } from 'components/Button';
import { useSupportCategories } from 'domains/support-section/hooks';
import { useNavigation } from 'utils/hooks/useNavigation';

export const SupportCategoriesList = () => {
  const { navigate, routes } = useNavigation();
  const { data } = useSupportCategories();

  const orderedCategoriesAlphabetically = orderBy(data, ['fields.categoryTitle'], ['asc']);
  const handleClick = (category: string) => navigate(`${routes.support.base}${category}`);

  return (
    <>
      <div className="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-16" data-testid="categories-group">
        {orderedCategoriesAlphabetically?.map(category => (
          <Button
            key={category.sys.id}
            data-testid={`category-${category.fields.categoryTitle}`}
            variant="secondary"
            size="md"
            className="col-span-1"
            endAdornment={<IconEndAdornment name="AngleRight" />}
            onClick={() => handleClick(category.fields.categoryTitle.toLowerCase())}
          >
            {category.fields.categoryTitle}
          </Button>
        ))}
      </div>
    </>
  );
};
